import { AppButtonIcon, AppButtonLoading } from '@components/@base/index'
import { ANALYZERS_ROUTES, BACKEND_APIS } from '@constants'
import { useToast } from '@hooks'
import { Box } from '@mui/material'
import { useSignal } from '@preact/signals-react'
import { getExcel, getSubmit } from '@ui-seeker/utils'
import React from 'react'

export default function AppTitleWithPopup(
	{
		realTimeSearchID,
		enabledAnalyzers = false,
		directSite = true,
		brokers = true,
		disable = false,
	}) {
	const { showToast } = useToast()
	const isLoadingGenSearch = useSignal(false)
	const isLoadingExpSearch = useSignal(false)
	const urlParams = `&hasCompetitionSites=${brokers}&hasDirectSites=${directSite}`
	return (
		<Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mr: 1 }}>
			{!!enabledAnalyzers && (
				<>
					<AppButtonIcon
						icon="tally"
						tooltip="LOR Analyzer"
						onClick={e => {
							window.open(`${ANALYZERS_ROUTES.LOR_PATH}?idSearch=${realTimeSearchID}${urlParams}`)
							if (e.ctrlKey || e.metaKey) e.preventDefault()
						}}
						disabled={disable}
					/>

					<AppButtonIcon
						icon="calendar-days"
						tooltip="DOR Analyzer"
						color="info"
						onClick={e => {
							window.open(`${ANALYZERS_ROUTES.DOR_PATH}?idSearch=${realTimeSearchID}${urlParams}`)
							if (e.ctrlKey || e.metaKey) e.preventDefault()
						}}
						disabled={disable}
					/>
					{(brokers || directSite) && (
						<AppButtonIcon
							icon="ranking-star"
							tooltip="Position Analyzer"
							color="secondary"
							onClick={() => {
								window.open(`${ANALYZERS_ROUTES.POSITION_PATH}?idSearch=${realTimeSearchID}${urlParams}`)
							}}
							disabled={disable}
						/>
					)}

					{brokers && <>
						<AppButtonIcon
							icon="handshake"
							tooltip="Brokers Analyzer"
							color="warning"
							onClick={e => {
								window.open(`${ANALYZERS_ROUTES.BROKERS_PATH}?idSearch=${realTimeSearchID}${urlParams}`)
								if (e.ctrlKey || e.metaKey) e.preventDefault()
							}}
							disabled={disable}
						/>

						<AppButtonIcon
							icon="star"
							tooltip="Rating Analyzer"
							color="warning"
							onClick={e => {
								window.open(`${ANALYZERS_ROUTES.RATING_PATH}?idSearch=${realTimeSearchID}${urlParams}`)
								if (e.ctrlKey || e.metaKey) e.preventDefault()
							}}
							disabled={disable}
						/>
					</>}

					{directSite && (
						<AppButtonIcon
							icon="chart-line"
							tooltip="Direct Site Analyzer"
							color="success"
							onClick={e => {
								window.open(`${ANALYZERS_ROUTES.DIRECT_SITE_PATH}?idSearch=${realTimeSearchID}${urlParams}`)
								if (e.ctrlKey || e.metaKey) e.preventDefault()
							}}
							disabled={disable}
						/>
					)}
					{!!realTimeSearchID && <AppButtonIcon
						onClick={() => {
							getExcel(`${BACKEND_APIS.CUSTOM_CATEGORY}/matches`, { idSearch: realTimeSearchID })
						}}
						onAuxClick={e => {
							if (e.button === 1) getExcel(`${BACKEND_APIS.CUSTOM_CATEGORY}/matches`, { idSearch: realTimeSearchID })
							e.preventDefault()
						}}
						sx={{ color: 'colors.deepOrange' }}
						tooltip="Get custom categories matches"
						icon="file-excel"
						disabled={disable}
					/>}
					{!!realTimeSearchID && <AppButtonIcon
						onClick={() => {
							getExcel(`${BACKEND_APIS.CUSTOM_ACRISS}/matches`, { idSearch: realTimeSearchID })
						}}
						onAuxClick={e => {
							if (e.button === 1) getExcel(`${BACKEND_APIS.CUSTOM_ACRISS}/matches`, { idSearch: realTimeSearchID })
							e.preventDefault()
						}}
						sx={{ color: 'colors.teal' }}
						tooltip="Get custom acriss matches"
						icon="file-excel"
						disabled={disable}
					/>}
					{isLoadingGenSearch.value && <AppButtonLoading sx={{ mt: .7 }}/>}
					{!isLoadingGenSearch.value && <AppButtonIcon
						icon="cloud-arrow-down"
						tooltip="Generate Search"
						color="success"
						onClick={() => {
							isLoadingGenSearch.value = true
							getSubmit(`${BACKEND_APIS.INTERMEDIARY}/generate-search`, { idSearch: realTimeSearchID })
								.then(({ url }) => {
									isLoadingGenSearch.value = false
									window.open(url)
								})
								.catch(() => {
									isLoadingGenSearch.value = false
									showToast.error()
								})
						}}
						disabled={disable}
					/>}
					{!!isLoadingExpSearch.value && <AppButtonLoading sx={{ mt: .7 }}/>}
					{!isLoadingExpSearch.value && <AppButtonIcon
						icon="file-arrow-down"
						tooltip="Export Search"
						color="info"
						onClick={() => {
							isLoadingExpSearch.value = true
							getSubmit(`${BACKEND_APIS.INTERMEDIARY}/export-search`, { idSearch: realTimeSearchID })
								.then(({ url }) => {
									isLoadingExpSearch.value = false
									window.open(url)
								})
								.catch(() => {
									isLoadingExpSearch.value = false
									showToast.error()
								})
						}}
						disabled={disable}
					/>}
				</>
			)}
		</Box>
	)
}
